const courseBrief = [
    {
        "id": "1",
        "title": "TAF 2021下半年訓練課程DM",
        "announcementDate": "2021-06-01T08:20:10.000Z",
        "file": ""
    },
    {
        "id": "2",
        "title": "TAF 2021下半年訓練課程DM",
        "announcementDate": "2021-12-09T08:20:10.000Z",
        "file": ""
    },
    {
        "id": "3",
        "title": "2020年 TAF訓練工服第4季課程DM",
        "announcementDate": "20229-09-08T08:20:10.000Z",
        "file": ""
    },
    {
        "id": "4",
        "title": "2020年 TAF訓練工服第3季課程DM",
        "announcementDate": "2020-06-01T08:20:10.000Z",
        "file": ""
    }
];

export default courseBrief;